<template>
    <div id="audit-data-list-datatable">
        <DataTable :value="auditDatas" :paginator="false" responsiveLayout="scroll" @row-click="onRowClick">
            <Column field="idEntreprise" :header="$t('ficheBu.audit_data_list.columns.1')" :sortable="true">
                <template #body="slotProps">
                    {{ getEntrepriseLabel(slotProps.data.idEntreprise) }}
                </template>
            </Column>
            <Column field="year" :header="$t('ficheBu.audit_data_list.columns.2')" :sortable="true">
                <template #body="slotProps">
                    {{ slotProps.data.year }}
                </template>
            </Column>
            <Column field="value" :header="$t('ficheBu.audit_data_list.columns.3')" :sortable="true">
                <template #body="slotProps">
                    {{ getAuditDataLabel(slotProps.data.value) }}
                </template>
            </Column>
            <Column style="width:100px">
                <template #body="slotProps">
                    <Button class="p-button-danger" icon="pi pi-trash" iconPos="right"
                        @click="deleteAuditData(slotProps.data.id)" />
                </template>
            </Column>
        </DataTable>
    </div>
</template>

<script>
import AsTitle from "../Elements/AsTitle.vue";
import DataTable from "primevue/datatable";
import Chip from "primevue/chip";
import Column from "primevue/column";
import Button from "primevue/button";
import moment from "moment";

export default {
    name: "AuditDataList",
    components: {
        AsTitle,
        DataTable,
        Chip,
        Column,
        Button,
    },
    props: {
        auditDatas: Array,
        entreprises: Array,
    },
    emits: ["onRowClick", "onDelete"],
    data() {
        return {};
    },
    methods: {
        getEntrepriseLabel(id) {
            const entreprise = this.entreprises.find(e => e.id === id)
            return entreprise ? entreprise.nom : ''
        },
        getAuditDataLabel(value) {
            return this.$t(`ficheBu.audit_data_list.value_enum.${value}`)
        },
        onRowClick(battle) {
            this.$emit("onRowClick", battle.data);
        },
        deleteAuditData(battleId) {
            this.$emit("onDelete", battleId);
        },
    },
};
</script>
<style lang="scss">
#audit-data-list-datatable {
    .p-datatable-wrapper {
        .p-datatable-tbody tr {
            cursor: pointer;
            transition: background-color 0.2s ease-in-out;

            &:hover {
                background-color: #f5f5f5;
            }
        }
    }
}
</style>